/**
 * Every path the app owns, in one place, so the router and the sidebar navigation cannot
 * drift apart. Both modules mount their `<Routes>` at the root, so a route's
 * segment and its link differ only by the leading slash.
 */
export const routeSegments = {
  login: 'login',
  authCallback: 'auth/callback',
  chat: 'chat',
  sources: 'sources',
  gardening: 'gardening',
} as const;

export const routes = {
  login: `/${routeSegments.login}`,
  /** Where Cognito redirects back to; `VITE_COGNITO_REDIRECT_URI` must end in it. */
  authCallback: `/${routeSegments.authCallback}`,
  chat: `/${routeSegments.chat}`,
  sources: `/${routeSegments.sources}`,
  gardening: `/${routeSegments.gardening}`,
} as const;

export const conversationRoute = (conversationId: string) => `${routes.chat}/${conversationId}`;
